import type { FirebaseWebConfig } from "../types/live";

/**
 * The web config is shipped base64-encoded in a single env var so one value can
 * be swapped per environment (dev/prod projects) without editing six variables.
 */
function readFirebaseConfig(): FirebaseWebConfig | null {
  const encoded = import.meta.env.VITE_FIREBASE_PLATFORM_CONFIG_B64 as string | undefined;
  if (!encoded) return null;

  try {
    const config = JSON.parse(atob(encoded)) as Partial<FirebaseWebConfig>;
    return config.apiKey && config.authDomain && config.projectId && config.appId
      ? (config as FirebaseWebConfig)
      : null;
  } catch {
    return null;
  }
}

export const FIREBASE_CONFIG = readFirebaseConfig();

export const isFirebaseConfigured = (): boolean => FIREBASE_CONFIG != null;
